function SvgComponent({ fillColor = '#4285F4', color = 'white', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={fillColor} />
      <path
        d="M14.2415 9.55202C12.766 8.84688 10.9138 8.78634 9.81729 10.1183C8.94764 11.1748 8.88705 12.6658 9.72818 13.7816C9.77452 13.8422 9.76382 13.854 9.69848 13.816C4.34044 10.7154 7.14539 3.00521 13.2757 4.10683C20.6142 5.29748 22.5055 15.0245 16.1412 18.8731C18.8226 15.9374 18.0551 11.4383 14.2415 9.55202Z"
        fill={color}
      />
      <path
        d="M7.88438 5.19895C4.85251 8.27589 6.40052 13.3685 10.3626 14.723C12.2635 15.4068 14.4019 14.7206 14.832 12.5577C14.9971 11.7232 14.8106 10.9468 14.2736 10.2322C14.2451 10.1942 14.2522 10.1859 14.2938 10.2097C16.2078 11.2697 17.4065 13.3163 17.1261 15.5148C16.0604 21.9666 7.65984 20.8436 5.07111 16.03C2.79959 12.2752 4.32978 7.08524 7.88438 5.19895Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
